import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { productApi, type Product } from '../../api/products';

export function ProductListPage() {
  const [items, setItems] = useState<Product[]>([]);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    void productApi
      .list(status ? { status } : undefined)
      .then(setItems)
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load products'))
      .finally(() => setLoading(false));
  }, [status]);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex flex-wrap justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">Products</h1>
          <p className="mt-1 text-sm text-slate-600">Master catalog of sellable and digital products.</p>
        </div>
        <div className="flex gap-3 text-sm">
          <Link to="/products/dashboard" className="text-slate-700 hover:underline">Dashboard</Link>
          <Link to="/products/search" className="text-slate-700 hover:underline">Search</Link>
          <Link to="/products/new" className="rounded-lg bg-slate-900 px-3 py-1.5 text-white">New product</Link>
        </div>
      </div>
      <select value={status} onChange={(e) => setStatus(e.target.value)} className="mt-6 rounded-lg border px-3 py-2 text-sm">
        <option value="">All statuses</option>
        <option value="draft">Draft</option>
        <option value="pending_approval">Pending approval</option>
        <option value="approved">Approved</option>
        <option value="published">Published</option>
        <option value="archived">Archived</option>
      </select>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {loading ? <p className="mt-6">Loading…</p> : (
        <div className="mt-6 overflow-x-auto rounded-xl border bg-white">
          <table className="min-w-full text-sm">
            <thead className="border-b bg-slate-50 text-left text-slate-600">
              <tr>
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">SKU</th>
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3">Type</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-b last:border-0">
                  <td className="px-4 py-3"><Link to={`/products/${p.id}`} className="font-medium hover:underline">{p.name}</Link></td>
                  <td className="px-4 py-3 text-slate-500">{p.identity?.sku || '—'}</td>
                  <td className="px-4 py-3 capitalize">{p.status.replace(/_/g, ' ')}</td>
                  <td className="px-4 py-3 capitalize">{p.type}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {items.length === 0 && <p className="p-6 text-slate-500">No products found.</p>}
        </div>
      )}
    </div>
  );
}
